import { Grid, Stack, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { CallSummaryResponse } from '../../../sic-lib/api/ai/types/Ai';
import { splitCamelCase } from '../../../sic-lib/utils/aiHelpers';
import AddCallAnalysisToNote from './AddCallAnalysisToNote';

interface Props {
    dataSummary: CallSummaryResponse | undefined;
    contactId: number;
}

export default function SummaryTab({ dataSummary, contactId }: Props) {
    const { classes } = useStyles();

    const summarizedData = React.useMemo(() => {
        let data: { [x: string]: string | string[] }[] = [];
        if (dataSummary && dataSummary.summary) {
            Object.entries(dataSummary.summary).forEach(([key, value]) => {
                if (value !== '' && value !== 'unknown' && key !== 'SentenceSummary')
                    data.push({ [splitCamelCase(key)]: value });
            });
        }
        return data;
    }, [dataSummary]);

    console.log('Summary', dataSummary);

    if (!dataSummary)
        return (
            <Typography variant="body1" mb={2}>
                Call Summary not available
            </Typography>
        );

    return (
        <>
            <Stack spacing={2} height="100%">
                <Typography variant="h6">Call Summary</Typography>

                <Grid container spacing={2}>
                    {
                        summarizedData.length > 0 &&
                            summarizedData.map((itm, index) => (
                                <Grid
                                    item
                                    key={`${Object.keys(itm)}-${index}`}
                                    xs={
                                        `${Object.keys(itm)}` === 'Call Summary' ||
                                        `${Object.keys(itm)}` === 'Property Information'
                                            ? 12
                                            : 4
                                    }
                                    flexDirection="row"
                                >
                                    <Typography
                                        className={classes.txtFormat}
                                        component="span"
                                        variant="caption"
                                    >
                                        {`${Object.keys(itm)}: `}
                                    </Typography>
                                    <Typography className={classes.txtFormat}>
                                        {Object.values(itm)}
                                    </Typography>
                                </Grid>
                            ))
                        /* Object.entries(dataSummary.summary).map(([key, value]) => (
                                <Typography key={key} className={classes.txtFormat}>
                                    {`${key}: ${value}`}
                                </Typography>
                            )) */
                    }
                </Grid>
                <AddCallAnalysisToNote transcriptSummary={summarizedData} contactId={contactId} />
            </Stack>
        </>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    txtFormat: {
        whiteSpace: 'pre-wrap',
    },
    detailsWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
    },
    details: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        justifyContent: 'center',
    },
    detailsData: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
    },
}));
